import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "components/basic/button";
import Typography from "components/basic/typography";

export interface ModalFooterProps {
  errors: string[];
  /** The customer had already approved this quote, so saving undoes that. */
  warnReapproval: boolean;
  saving: boolean;
  onSave: () => void;
  onClose: () => void;
}

const ModalFooter: React.FC<ModalFooterProps> = ({
  errors,
  warnReapproval,
  saving,
  onSave,
  onClose,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("leads");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
      }}
    >
      {warnReapproval && (
        <Typography variant="body2" color="error">
          {t("revise.reapproval_warning")}
        </Typography>
      )}

      {errors.map((error) => (
        <Typography key={error} variant="body2" color="error">
          {error}
        </Typography>
      ))}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: theme.spacing(1),
        }}
      >
        <Button variant="text" onClick={onClose} disabled={saving}>
          {t("revise.cancel")}
        </Button>
        <Button
          variant="contained"
          loading={saving}
          disabled={saving || errors.length > 0}
          onClick={onSave}
        >
          {t("revise.save")}
        </Button>
      </div>
    </div>
  );
};

export default ModalFooter;
